import React from 'react'
import { AuthTemplateView } from '~/components'
import { LoginForm } from './components'

export const Login: React.FC = () => {
  return (
    <AuthTemplateView
      title='Entre na sua conta'
      description='Insira seus dados para acompanhar a solicitação de crédito para a sua empresa.'
    >
      <LoginForm />
    </AuthTemplateView>
  )
}
